import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ScratchCard from './pages/ScratchCard';
import PrizesHistory from './pages/PrizesHistory';
import NotFound from './pages/NotFound';
import UserDataForm from './components/UserDataForm';
import BusinessDashboard from './pages/BusinessDashboard';
import BusinessLogin from './pages/BusinessLogin';
import AdminLogin from './pages/AdminLogin';
import CampaignsList from './pages/admin/CampaignsList';
import CampaignForm from './pages/admin/CampaignForm';
import AdminRoute from './components/AdminRoute';
import CampaignDetail from './pages/admin/CampaignDetail';
import LandingPage from './pages/LandingPage';

// Creamos un componente separado para las rutas
const AppRoutes = () => {
  const { showUserForm } = useAuth();
  
  return (
    <Routes>
      <Route path="/negocios" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route 
        path="/" 
        element={
          <PrivateRoute>
            {showUserForm ? <UserDataForm /> : <PrizesHistory />}
          </PrivateRoute>
        } 
      />
      <Route 
        path="/campaign/:slug" 
        element={
          <PrivateRoute>
            <ScratchCard />
          </PrivateRoute>
        } 
      />
      <Route 
        path="/test/:testUrl" 
        element={
          <PrivateRoute>
            <ScratchCard />
          </PrivateRoute>
        } 
      />
      <Route path="/business/:adminUrl" element={<BusinessLogin />} />
      <Route path="/business/dashboard/:adminUrl" element={<BusinessDashboard />} />
      <Route path="/pmpl/admin" element={<AdminLogin />} />
      <Route element={<AdminRoute />}>
        <Route path="/pmpl/admin/dashboard" element={<CampaignsList />} />
        <Route path="/pmpl/admin/campaigns/new" element={<CampaignForm />} />
        <Route path="/pmpl/admin/campaigns/:id/edit" element={<CampaignForm />} />
        <Route path="/pmpl/admin/campaigns/:id" element={<CampaignDetail />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App; 